module.exports = __webpack_public_path__ + "29eec456.otf";